"use client";

import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio"; // Ensure this is imported

const testimonials = [{
  author: "Don",
  quote: "SAMMY JR at just 1 year and 1 day old is already surfing open faced waves. Bringing home his second BRONZE medal in the small dog category, his first year in competition in the Helen Woodward Animal Center 2025 Competition. “It is quite a surprise that our JR is doing well with surfing at such a young age, just 1 year old. I have probably been involved in training more than 200 dogs for surfing and never have I seen any dog like our SPECIAL BOY. We do love him soooo much, thank you for loving the Cavalier and doing such a great job as a breeder.”",
  position: "SAMMY'S DAD",
  // 1. ADDED IMAGE LINK HERE:
  image: "https://brave-rhino.10web.cloud/wp-content/uploads/2026/03/Sammy-JR-scaled.jpeg?v=hpem1nk8c08" // PASTE SAMMY'S SURFING PHOTO URL HERE
}];
export default function GuestExperiences() {
  const [api, setApi] = React.useState<CarouselApi>();
  React.useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 8000); // Increased interval to 8 seconds since the quote is long
    return () => clearInterval(interval);
  }, [api]);
  return <section data-section-id="83433" id="words-from-our-puppy-parents" className="py-24 bg-background overflow-hidden relative">
      
      {/* Visual Background Element (Faint Purple Blob) */}
      <div className="absolute inset-0 pointer-events-none opacity-10 flex justify-center items-center">
        <div className="h-[30rem] w-[30rem] rounded-full bg-primary blur-3xl" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <Carousel setApi={setApi} opts={{
        loop: true,
        align: "center",
        duration: 40
      }} className="w-full relative">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center text-center px-4 md:px-16 py-8 transition-opacity duration-500">
                  
                  {/* 2. THE NEW PHOTO UI (Circular with modern borders) */}
                  {testimonial.image && <div className="relative size-32 md:size-40 mb-12 flex-shrink-0 mx-auto">
                      {/* Decorative outer rings for a high-end look */}
                      <div className="absolute -inset-2.5 rounded-full border-2 border-primary/20 animate-pulse" />
                      <div className="absolute -inset-1 rounded-full border border-secondary" />
                      
                      {/* The circular image */}
                      <div className="relative size-full rounded-full overflow-hidden border-4 border-background shadow-xl bg-muted">
                        <img src={testimonial.image} alt={`Sammy Jr. with ${testimonial.author}`} className="w-full h-full object-cover" />
                      </div>
                    </div>}

                  <p className="font-serif italic text-[22px] md:text-[26px] leading-relaxed text-foreground mb-10 max-w-3xl mx-auto drop-shadow-sm">
                    "{testimonial.quote}"
                  </p>
                  
                  <div className="flex items-center justify-center gap-1.5 mb-6">
                    {[...Array(5)].map((_, j) => <Star key={j} data-index={j} className="size-6 text-primary fill-primary" aria-hidden="true" />)}
                  </div>
                  
                  <div className="flex flex-col items-center gap-1.5">
                    <span className="font-sans font-bold text-secondary-foreground text-lg tracking-wide">
                      {testimonial.author}
                    </span>
                    <span className="font-sans text-muted-foreground text-sm uppercase tracking-wider font-medium">
                      {testimonial.position}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="left-0 lg:-left-12 bg-background/80 hover:bg-accent border-border text-primary shadow-sm transition-colors" />
            <CarouselNext className="right-0 lg:-right-12 bg-background/80 hover:bg-accent border-border text-primary shadow-sm transition-colors" />
          </div>
        </Carousel>
      </div>
    </section>;
}